import { defineMessages } from 'react-intl-next';

export type PullRequestStatusValue = 'open' | 'merged' | 'declined' | 'draft' | 'unknown';

export const pullRequestStatuses: PullRequestStatusValue[] = [
	'open',
	'merged',
	'declined',
	'draft',
	'unknown',
];

export const i18n: Record<PullRequestStatusValue, import('react-intl-next').MessageDescriptor> =
	defineMessages<PullRequestStatusValue>({
		open: {
			id: 'search-page.filter.pull-request-status.open',
			defaultMessage: 'Open',
			description: 'Open status for a pull request',
		},
		merged: {
			id: 'search-page.filter.pull-request-status.merged',
			defaultMessage: 'Merged',
			description: 'Merged status for a pull request',
		},
		declined: {
			id: 'search-page.filter.pull-request-status.declined',
			defaultMessage: 'Declined',
			description: 'Declined status for a pull request',
		},
		draft: {
			id: 'search-page.filter.pull-request-status.draft',
			defaultMessage: 'Draft',
			description: 'Draft status for a pull request',
		},
		unknown: {
			id: 'search-page.filter.pull-request-status.unknown',
			defaultMessage: 'Unknown',
			description: 'Unknown status for a pull request',
		},
	});
